/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskPolicyBypassApprovalRequestBody,
  RiskPolicyBypassApprovalRequestBody$Outbound,
  RiskPolicyBypassApprovalRequestBody$outboundSchema,
} from "../components/riskpolicybypassapprovalrequestbody.js";

export type ApproveRiskPolicyBypassRequestSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ApproveRiskPolicyBypassRequestSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ApproveRiskPolicyBypassRequestSecurity = {
  option1?: ApproveRiskPolicyBypassRequestSecurityOption1 | undefined;
  option2?: ApproveRiskPolicyBypassRequestSecurityOption2 | undefined;
};

export type ApproveRiskPolicyBypassRequestRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskPolicyBypassApprovalRequestBody: RiskPolicyBypassApprovalRequestBody;
};

/** @internal */
export type ApproveRiskPolicyBypassRequestSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ApproveRiskPolicyBypassRequestSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ApproveRiskPolicyBypassRequestSecurityOption1$Outbound,
    ApproveRiskPolicyBypassRequestSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function approveRiskPolicyBypassRequestSecurityOption1ToJSON(
  approveRiskPolicyBypassRequestSecurityOption1:
    ApproveRiskPolicyBypassRequestSecurityOption1,
): string {
  return JSON.stringify(
    ApproveRiskPolicyBypassRequestSecurityOption1$outboundSchema.parse(
      approveRiskPolicyBypassRequestSecurityOption1,
    ),
  );
}

/** @internal */
export type ApproveRiskPolicyBypassRequestSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ApproveRiskPolicyBypassRequestSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ApproveRiskPolicyBypassRequestSecurityOption2$Outbound,
    ApproveRiskPolicyBypassRequestSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function approveRiskPolicyBypassRequestSecurityOption2ToJSON(
  approveRiskPolicyBypassRequestSecurityOption2:
    ApproveRiskPolicyBypassRequestSecurityOption2,
): string {
  return JSON.stringify(
    ApproveRiskPolicyBypassRequestSecurityOption2$outboundSchema.parse(
      approveRiskPolicyBypassRequestSecurityOption2,
    ),
  );
}

/** @internal */
export type ApproveRiskPolicyBypassRequestSecurity$Outbound = {
  Option1?: ApproveRiskPolicyBypassRequestSecurityOption1$Outbound | undefined;
  Option2?: ApproveRiskPolicyBypassRequestSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ApproveRiskPolicyBypassRequestSecurity$outboundSchema:
  z.ZodMiniType<
    ApproveRiskPolicyBypassRequestSecurity$Outbound,
    ApproveRiskPolicyBypassRequestSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        ApproveRiskPolicyBypassRequestSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        ApproveRiskPolicyBypassRequestSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function approveRiskPolicyBypassRequestSecurityToJSON(
  approveRiskPolicyBypassRequestSecurity:
    ApproveRiskPolicyBypassRequestSecurity,
): string {
  return JSON.stringify(
    ApproveRiskPolicyBypassRequestSecurity$outboundSchema.parse(
      approveRiskPolicyBypassRequestSecurity,
    ),
  );
}

/** @internal */
export type ApproveRiskPolicyBypassRequestRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskPolicyBypassApprovalRequestBody:
    RiskPolicyBypassApprovalRequestBody$Outbound;
};

/** @internal */
export const ApproveRiskPolicyBypassRequestRequest$outboundSchema:
  z.ZodMiniType<
    ApproveRiskPolicyBypassRequestRequest$Outbound,
    ApproveRiskPolicyBypassRequestRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      riskPolicyBypassApprovalRequestBody:
        RiskPolicyBypassApprovalRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        riskPolicyBypassApprovalRequestBody:
          "RiskPolicyBypassApprovalRequestBody",
      });
    }),
  );

export function approveRiskPolicyBypassRequestRequestToJSON(
  approveRiskPolicyBypassRequestRequest: ApproveRiskPolicyBypassRequestRequest,
): string {
  return JSON.stringify(
    ApproveRiskPolicyBypassRequestRequest$outboundSchema.parse(
      approveRiskPolicyBypassRequestRequest,
    ),
  );
}
